module.exports = __webpack_public_path__ + "static/why-planet.ff6c0fcc.jpg";